import { useCartContext } from '../components'

export const useCartPlugin = () => {
  const { cartManager } = useCartContext()
  return cartManager.plugin
}
